<body class="vertical-layout vertical-menu 2-columns   menu-expanded    pace-done pace-done" style="background-color: #fff;">
	<section class="page_404">
		<div class="container">
			<div class="row">	
			<div class="col-sm-12 ">
			<div class="col-sm-10 col-sm-offset-1  text-center">
			<div class="four_zero_four_bg">
				<h1 class="text-center ">404</h1>
			
			
			</div>
			
			<div class="contant_box_404">
			<h3 class="h2">
		  Parece que você está perdido
			</h3>
			
			<p>a página que você está procurando não está disponível!</p>
			
			<a  class="col-sm-2 link_404 btn border-radius btn-outline-success btn-block"href="javascript:void(0)" (click)="onRedirectHome()" >Ir para Home</a>
			
		</div>
			</div>
			</div>
			</div>
		</div>
	</section>
</body>